import React, { useEffect, useState } from 'react'
import SearchIcon from '@icons/search.inline.svg'
import ClearIcon from '@icons/clear.inline.svg'
import { SButtonHeader } from '@components/Button/Button'
import Form from '@api/Form'
import useDebouncedCallback from '@utils/debounce'
import AutocompleteList from './AutocompleteList'
import AutocompleteItem from './AutocompleteList/AutocompleteItem'

const AutoCompleteSearch: React.FC = () => {
  const DEBOUNCE_TIME = 300

  const [search, setSearch] = useState('')
  const [items, setItems] = useState<false | JSX.Element[]>(false)

  useEffect(() => {}, [items])

  const generateItems = (value: string) => {
    Form.getAutocompleteValues(value)
      .then(({ data }) => {
        const dataResult = Object.entries(data.result)
        if (data.status === 'success' && dataResult.length > 0) {
          return dataResult.map((value, key) => <AutocompleteItem value={value[1].PHRASE} key={key} />)
        }
        return false
      })
      .then((data) => setItems(data))
  }

  const debouncedGenerate = useDebouncedCallback((value: string) => generateItems(value), DEBOUNCE_TIME)

  const inputChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setSearch(value)
    if (value.length > 0) {
      debouncedGenerate(value)
    }
  }

  return (
    <div className="npf-header-search">
      <div className="npf-header-search__container npf-tile">
        <form className="npf-header-search__form" action="/search/">
          <div className="npf-header-search__icon">
            <SearchIcon />
          </div>
          <input
            className="npf-header-search__field npf-typo npf-typo_size_default npf-typo_size_large_xl"
            name="q"
            value={search}
            onChange={inputChangeHandler}
            type="text"
            placeholder="Поиск по сайту"
            autoComplete="off"
          />
          {search !== '' && (
            <div className="npf-header-search__clear">
              <ClearIcon onClick={() => setSearch('')} />
            </div>
          )}
          <SButtonHeader value="Найти" type="submit" type="primaryGreen">
            Найти
          </SButtonHeader>
        </form>
        {items && items.length > 0 && <AutocompleteList>{items}</AutocompleteList>}
      </div>
    </div>
  )
}

export default AutoCompleteSearch
